<section class="verify-body">
    <h2 class="font-semibold" style="display: flex; align-items: center;">
      <button mat-icon-button (click)="state.emit('request');"><mat-icon>arrow_left</mat-icon></button>
      <!-- <mat-icon matRipple (click)="verifying = false;">arrow_left</mat-icon> -->
      <span style="width: 100%;">Phone Confirmation</span>
      <div style="min-width: 40px; height: 1px;"></div><!--spacer-->
    </h2>

    <p>
      We've sent you a {{codeLength}}-digit code by SMS to your phone number@if(phone(); as phone){<span class="font-bold"> {{phone}}</span>}. Please enter it below:
    </p>

    <div class="verify-code" #verifyCodeInputs>
      @for(digit of codeForm.controls; let i = $index; track i; let first = $first; let last = $last;){
        <input 
        [formControl]="digit" 
        matInput 
        [class.cosmetic]="loading()" 
        inputmode="tel"
        type="text" maxlength="1" autocomplete="off" 
        (focus)="selectElement($event.target)" 
        (paste)="onPaste($event, i)" 
        (keydown.Backspace)="$event.preventDefault(); digit.setValue('')" 
        (keydown.ArrowLeft)="$event.preventDefault(); !first ? focusElement(verifyCodeInputs.children[i-1]) : {}" 
        (keydown.ArrowRight)="$event.preventDefault(); !last ? focusElement(verifyCodeInputs.children[i+1]) : {}">
      }
    </div>

    <button mat-flat-button color="primary" rounded class="login-button" type="button" (click)="confirmVerification()" [disabled]="loading || !form.valid">
      <span class="font-semibold">{{loading() ? 'Loading...' : 'Verify'}}</span>
    </button>
    <br/>
    <br/>
    <p class="font-light m-0 text-center">Didn't receive a code?</p>
    @if(timer){
      <p class="font-light m-0 text-center">Retry in {{timerValue()}}</p>
    } @else {
      <br/>
      <button mat-stroked-button color="primary" rounded class="login-button" type="button" (click)="resendVerification()" [disabled]="loading">
        <span class="font-semibold">{{loading() ? 'Loading...' : 'Resend SMS'}}</span>
      </button>
    }
  </section>